/*
 * @Description: 爆料管理服务
 * @Author: pu.yuchun
 * @LastEditors: pu.yuchun
 * @Date: 2017-12-5
 * @LastEditTime: 2019-10-28 12:20:39
 */
'use strict';
angular
    .module('explosionManageServiceModule', [
        'createExplosionModule' //新增爆料
    ])
    .factory('explosionManageService', [
        '$modal',
        '$q',
        function($modal, $q) {
            return {
                /**
                 * [createProduct description] 新增爆料
                 * @param {[string]} [content] [description] 内容
                 * @param {[string]} [item] [description] 当前选择对象（只有编辑状态才有）
                 */
                createExplosion: function(content, item) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl:
                            './main/submissionManage/explosionManage/service/createExplosion/createExplosion_tpl.html',
                        windowClass: 'createExplosionCtrl',
                        backdrop: false,
                        keyboard: false,
                        controller: 'createExplosionCtrl',
                        resolve: {
                            content: function() {
                                return content;
                            },
                            item: function() {
                                return item;
                            }
                        }
                    });
                    modalInstance.result.then(function(result) {
                        deffer.resolve(result);
                    });
                    return deffer.promise;
                }
            };
        }
    ]);
